import { render, staticRenderFns } from "./ManageServiceType.vue?vue&type=template&id=1fe1472a"
import script from "./ManageServiceType.vue?vue&type=script&lang=js"
export * from "./ManageServiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports